export const IMG_WOS = '//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/';
export const CDN_WOS = '//wos.58cdn.com.cn/';